import { Component, Input, Output, EventEmitter, ViewChild, ElementRef, Renderer2, AfterViewChecked } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Moment } from 'moment';
import * as moment from 'moment';
import * as fileSaver from 'file-saver';

import { SlickGridComponent } from 'app/slick-grid/slick-grid.component';
import { BufferGraphService } from 'app/buffer-graph/services/buffer-graph.service';
import { BufferChangeHistory } from 'app/buffer-graph/models/buffer-change-history/buffer-change-history';
import { ISlickGridColumn } from 'app/slick-grid/interfaces/slick-grid-column';
import { Formatters } from 'app/slick-grid/models/formatters';
import { OnDropdownFilteredEventArgs } from 'app/slick-grid/models/on-dropdown-filtered-event-args';
import { DropdownFilterType } from 'app/slick-grid/interfaces/dropdown-filter-type';
import { EventArgs } from 'app/slick-grid/models/event-args';
import { TabComponentBase } from 'app/buffer-graph/models/tab-component-base';

@Component({
    selector: 'buffer-change-history',
    templateUrl: './buffer-change-history.component.html',
    styleUrls: ['./buffer-change-history.component.css']
})
export class BufferChangeHistoryComponent extends TabComponentBase<BufferChangeHistory, { columns: { header: string, field: string }[], rows: string[][] }> implements AfterViewChecked {
    constructor(graphService: BufferGraphService, private readonly translateService: TranslateService, private readonly renderer: Renderer2, private readonly elementRef: ElementRef) {
        super(graphService);

        this.showAllData = new EventEmitter<void>();

        this.dataView = new Slick.Data.DataView<BufferChangeHistory>();
        this.options = { syncColumnCellResize: true, multiColumnSort: true, editable: false };
    }

    @ViewChild('grid')
    protected gridRef: SlickGridComponent;

    @Input()
    protected isActive: boolean;

    @Input()
    private allShown: boolean;

    private data: BufferChangeHistory[];
    @Input()
    private set changes(changes: BufferChangeHistory[]) {
        this.data = changes;

        this.dropdownFilters = [];

        this.dataView.beginUpdate();
        this.dataView.setItems(changes);
        this.dataView.setFilter(o => this.filterChangeHistory(o));
        this.dataView.endUpdate();
    }

    @Input()
    protected sku: string;

    @Input()
    protected warehouseCode: string;

    @Input()
    protected canSend: boolean;

    @Output()
    private readonly showAllData: EventEmitter<void>;

    private dropdownFilters: OnDropdownFilteredEventArgs<BufferChangeHistory>[];

    ngAfterViewChecked(): void {
        if (this.columns == null)
            setTimeout(() => this.columns = [
                { id: 'date', field: 'date', name: 'Date', sortable: true, formatter: (r, c, v) => Formatters.dateFormatter(r, c, v), dropdownFilter: { dropdownContainer: this.elementRef.nativeElement, renderer: this.renderer, displayFormatter: v => Formatters.dateFormatter(null, null, v), sortFormatter: v => v == null ? '' : (v as Moment).format('YYYY-MM-DD HH:mm:ss') } },
                { id: 'parameter', field: 'parameter', name: 'Parameter', sortable: true, dropdownFilter: { dropdownContainer: this.elementRef.nativeElement, renderer: this.renderer/*, displayFormatter: v => v, sortFormatter: v => v == null ? '' : v*/ } },
                { id: 'reason', field: 'reason', name: 'Reason', sortable: true, dropdownFilter: { dropdownContainer: this.elementRef.nativeElement, renderer: this.renderer/*, displayFormatter: v => v, sortFormatter: v => v == null ? '' : v*/ } },
                { id: 'oldValue', field: 'oldValue', name: 'OldValue', sortable: true, formatter: (r, c, v) => Formatters.numberFormatter(r, c, v, 4) },
                { id: 'newValue', field: 'newValue', name: 'NewValue', sortable: true, formatter: (r, c, v) => Formatters.numberFormatter(r, c, v, 4) }
            ],
                1);
    }

    protected getExportData = this.getExportDataByDefault;

    private filterChangeHistory = (changeHistory: BufferChangeHistory): boolean => {
        for (const filter of this.dropdownFilters) {
            const value = changeHistory[filter.column.field];

            let result: boolean;

            switch (filter.type) {
                case DropdownFilterType.Blank:
                    result = value == null || value === '';
                    break;
                case DropdownFilterType.NonBlank:
                    result = value != null && value !== '';
                    break;
                case DropdownFilterType.ByValue:
                    result = moment.isMoment(filter.value) ? filter.value.isSame(value) : filter.value === value;
                    break;
                default:
                    result = true;
            }
            if (!result)

                return false;
        }

        return true;
    }

    private onShowAllClick = (): void => {
        if (this.allShown)
            return;

        this.showAllData.emit();
    }

    private onDownloadClick = (): void => {
        const fileName = `BufferHistory_SKU_${this.sku}_Wrh_${this.warehouseCode}.xlsx`;
        this.translateService.get('BufferChangeHistory').subscribe(t => {
            this.download(data => this.graphService.downloadBufferChangeHistory(data.columns, data.rows, moment.locale(), t)
                .map(file => { return { fileContent: file, fileName }; }));
        });
    }

    private onSendClick = (): void => {
        this.translateService.get('BufferChangeHistory').subscribe(t => {
            this.sendToEmail(data => this.graphService.sendBufferChangeHistory(this.sku, this.warehouseCode, data.columns, data.rows, moment.locale(), t));
        });
    }

    //private onHideExportErrorClick = (): void => {
    //    setTimeout(() => this.showExportError = false, 500);
    //}

    //private onHideSendErrorClick = (): void => {
    //    setTimeout(() => this.showSendError = false, 500);
    //}

    //private onHideSendSuccessClick = (): void => {
    //    setTimeout(() => this.showSendSuccess = false, 500);
    //}

    private onGridDropdownFiltered = (args: EventArgs<OnDropdownFilteredEventArgs<BufferChangeHistory>>): void => {
        const idx = this.dropdownFilters.findIndex(f => f.column.field === args.data.column.field);
        if (idx >= 0)
            this.dropdownFilters.splice(idx, 1);

        if (args.data.type === DropdownFilterType.All) {
            if (idx < 0)
                return;
        } else
            this.dropdownFilters.push(args.data);

        this.dataView.refresh();
    }
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/components/buffer-change-history.component/buffer-change-history.component.ts